import './src/stylesheets/styles.scss'
import '@fontsource/licorice'

import { stickUtmParameters } from './src/utm'
import { freshpaint, freshpaintTrack } from './src/freshpaint'
import { amplitudeAnalytics } from './src/amplitude'
import { tradeDesk } from './src/tradedesk'
import ReportingAdapter from './src/reporting/reporting-adapter'

export const onClientEntry = (): void => {
  freshpaint()
  stickUtmParameters()
  amplitudeAnalytics()
  tradeDesk()

  // Ensure the new SDKs are initialized
  // This will initialize both Amplitude and Segment SDKs.
  new ReportingAdapter(undefined)
}

export const onRouteUpdate = () => {
  setTimeout(() => {
    freshpaintTrack('engaged_page_views')
  }, 30000)
}
